var exports = {
  "k": "x127c5a35--0572fe--container",
  "h": "x127c5a35--0572fe--description",
};

module.exports = exports;
